import template from './job-details.html';
import controller from './job-details.controller';
import './job-details.styl';

let jobDetailsComponent = {
  template,
  controller,
  controllerAs: 'vm'
};

export default jobDetailsComponent;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-details/job-details.component.js
 **/